/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './appointmentModal.module.css';
import { useTranslation } from 'react-i18next';
import { ReactComponent as More } from '../../../src/assets/SVG/close-circle-greay.svg';
import { useAlert } from '../alertProvider';
import { ConfirmationModal } from '../confirmationModal';
import { TextField, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, Tabs, Tab, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, InputAdornment, Autocomplete, CircularProgress, RadioGroup, Radio, Stack, Grid2 } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { ReactComponent as SearchIcon } from '../../../src/assets/SVG/Search-Icon.svg'; // Ensure correct path and use ReactComponent for SVG
import {
  fetchPatientList,
  getPatientDetails,
  appointmentReasons,
  useDebounce,
  postBookAppointment,
  getGender,
  postPatientPartnerInfo,
  getWorkingHours,
  getcountrycode,
  getRooms,
  getOTtables,
  departmentsByClinic,
  getUsersByClinic,
  getUserDetailsById,
  clinic,
  getUsersByClinicAndTime,
  fetchPatientFullList
} from '../../services/apiService';
import {
  Patient,
  Patientv2,
  AppointmentReasons,
  userListRoleWise, 
  AppointmentFormErrorsType,
  bookSlotPatientData,
  Gender,
  AppointmentModalProps,
  ValidationErrors1,
  DepartmentDetail,
  UserBasic
} from '../../types';
import PatientDetails from './PatientDetails/patientDetails';
import PreviousVisits from './PreviousVisits/previousHistory';
import theme from '../../utils/theme';
import { convertDateToISOWithOffset, formatDateToISOWithOffsetFilter } from '../../services/time';
import { useClinic } from '../ClinicProvider';
import { useLoader } from '../loaderProvider/loader';
import { LabeledWithAsterisk, RequiredLabel, timeDifference, toTitleCase, validateEmail } from '../../utils/commonUtils';
import registrationTypesEnum from '../../mocks/registrationTypesEnum';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { getClinicList, Clinic } from '../../pages/Configuration/User/UserDetails/UserDetails.helper';
import { getButtonStates } from '../../utils/permissionService';

// Appointment Type Options
export interface AppointmentTypeOption {
  labelKey: string;
  value: string;
}

export const APPOINTMENT_TYPE_OPTIONS: AppointmentTypeOption[] = [
  { labelKey: 'appointmentTypeWalkIn', value: 'WALK_IN' },
  { labelKey: 'appointmentTypeOnline', value: 'ONLINE' },
];

export interface PatientData {
  firstName: string;
  lastName: string;
  gender: string;
  mobile: string;
  dob: string;
  email: string;
  mobile_country_code?: string,
}

export interface PartnerData extends PatientData {
  isPartnerSelected: boolean;
}


export default function AppointmentModal({
  resource,
  open,
  onClose,
  slotDate,
  slotDepartment,
  departmentName = 'Admin',
  departmentTabs, 
  handleTabChange,
  view
}: AppointmentModalProps) {
  const { t: tAppointmentForm, i18n } = useTranslation('appointment_form');
  const convertToDate = (date: Date | string): Date => {
    return typeof date === 'string' ? new Date(date) : date;
  };

  const formattedSlotDate = convertToDate(slotDate || new Date());
  // keep Date for logic
  const [appointmentDate, setAppointmentDate] = useState<Date>(formattedSlotDate || new Date());

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // keep string for input binding - use formatDate for local timezone
  const [appointmentDateStr, setAppointmentDateStr] = useState<string>(
    formatDate(formattedSlotDate)
  );
  const [isGenderDisabled, setIsGenderDisabled] = useState(false);

  const formatTime = (date: Date): string => {
    return date.toTimeString().split(':').slice(0, 2).join(':');
  };

  const addMinutes = (date: Date, minutes: number): Date => {
    return new Date(date.getTime() + minutes * 60000);
  };
  // keep initial state as it is (based on slotDate)
  const [timeFrom, setTimeFrom] = useState<string>(formatTime(formattedSlotDate));
  const [timeTo, setTimeTo] = useState<string>(formatTime(addMinutes(formattedSlotDate, 15)));

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Validates only one "@" and no spaces

  const [selectedDepartment, setSelectedDepartment] = useState(slotDepartment || '');
  const { ClinicId } = useClinic();
  const { addAlert } = useAlert();
  const { showLoader, hideLoader } = useLoader();
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [isPatientSelected, setIsPatientSelected] = useState(false);
  const [patientSearchTerm, setPatientSearchTerm] = useState('');
  const [patients, setPatients] = useState<Patient[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedPatientDetails, setSelectedPatientDetails] = useState<Patientv2 | null>(null);
  const [departmentList, setDepartmentList] = useState<DepartmentDetail[]>([]);
  const [appointmentReasonsList, setAppointmentReasonsList] = useState<AppointmentReasons[]>([]);
  const [roleList, setRoleList] = useState<UserBasic[]>([]);
  // const [availableRoleList, setAvailableRoleList] = useState<UserBasic[]>([]);

  // const [finalRoleList, setFinalRoleList] = useState<UserBasic[]>([]);
  
  // OLD LOGIC: Comparing two lists to determine availability
  // const sortedRoleList = useMemo(() => {
  //   if (!roleList?.length) return [] as UserBasic[];
  //   const availableIds = new Set(availableRoleList.map(u => u.id));
  //   return [...roleList].sort((a, b) => {
  //     const aAvail = availableIds.has(a.id) ? 1 : 0;
  //     const bAvail = availableIds.has(b.id) ? 1 : 0;
  //     if (aAvail !== bAvail) return bAvail - aAvail; // available first
  //     // Stable secondary sort by name
  //     const aName = `${a.first_name || ''} ${a.last_name || ''}`.trim().toLowerCase();
  //     const bName = `${b.first_name || ''} ${b.last_name || ''}`.trim().toLowerCase();
  //     return aName.localeCompare(bName);
  //   });
  // }, [roleList, availableRoleList]);

  // NEW LOGIC: Using is_available flag from getUsersByClinicAndTime API
  // roleList now contains all users with is_available flag
  const sortedRoleList = useMemo(() => {
    if (!roleList?.length) return [] as UserBasic[];
    return [...roleList].sort((a, b) => {
      const aAvail = a.is_available ? 1 : 0;
      const bAvail = b.is_available ? 1 : 0;
      if (aAvail !== bAvail) return bAvail - aAvail; // available first
      // Stable secondary sort by name
      const aName = `${a.first_name || ''} ${a.last_name || ''}`.trim().toLowerCase();
      const bName = `${b.first_name || ''} ${b.last_name || ''}`.trim().toLowerCase();
      return aName.localeCompare(bName);
    });
  }, [roleList]);
  
  const [selectedAppointmentReason, setSelectedAppointmentReason] = useState<number | undefined>(undefined);
  const [selectedPersonnel, setSelectedPersonnel] = useState<UserBasic | undefined>(undefined);
  const [selectedAppointmentMode, setSelectedAppointmentMode] = useState<string>('WALK_IN');
  // const [inputValue, setInputValue] = useState('');
  // const debouncedInputValue = useDebounce(inputValue, 300); // Debounce for 300ms
  const { canAdd } = getButtonStates('Admin', 'Calendar', departmentName);

  useEffect(() => {
    if (resource){
      const id = Number(resource);
      if (!Number.isNaN(id)) {
        getUserDetailsById(Number(resource)).then((user: UserBasic) => setSelectedPersonnel(user));
      }
    }
  }, [resource]);

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const currentDate = formatDate(new Date());
  const [remark, setRemark] = useState('');
  const [genders, setGenders] = useState<Gender[]>([]);
  const [checkboxState, setCheckboxState] = useState({
    patient: true,
    partner: false,
    oocyteDonor: false,
    spermDonor: false,
    surrogate: false
  });

  const [patientType, setPatientType] = useState('PATIENT_SINGLE');
  const [formErrors, setFormErrors] = useState<AppointmentFormErrorsType>({
    department: '', personnel: '', appointmentReason: '', appointmentDate: '',
    timeFrom: '', timeTo: '', remark: '', room:'', table:'  '
  });

  const [countryCodes, setCountryCodes] = useState<any[]>([]);
  const [filteredCountryCodes, setFilteredCountryCodes] = useState<any[]>([]);
  const [room, setRoom] = useState<any[]>([]);
  const [selectedRoom, setSelectedRoom] = useState<number | undefined>(undefined);
  const [table, setTable] = useState<any[]>([]);
  const [selectedTable, setSelectedTable] = useState<number | undefined>(undefined);
  const [clinicList, setClinicList] = useState<Clinic[]>([]);
  const [selectedClinic, setSelectedClinic] = useState<number | undefined>(undefined);

    
  const [selectedValue, setSelectedValue] = useState<Patient | null>(null);
  const [inputFocused, setInputFocused] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [isPatientDropdownOpen, setIsPatientDropdownOpen] = useState(false);

  const requiredFields: (keyof AppointmentFormErrorsType)[] = ['department','appointmentReason',
    'appointmentDate','timeFrom','timeTo'];

  const isSurgeryDepartment = departmentList.some(department => department.id === slotDepartment && department.name === 'Surgery');
  if (isSurgeryDepartment) {
    departmentName = 'Surgery';
    requiredFields.push('room', 'table');
  }

  const debouncedSearchTerm = useDebounce(patientSearchTerm, 300);

  const validateForm = () => {
    setIsFormSubmitted(true);
    const newErrors: AppointmentFormErrorsType = {};
    const currentTime = new Date(); // Capture current time once for consistent validation
    const fieldValues = {
      department: selectedDepartment,
      personnel: selectedPersonnel,
      appointmentReason: selectedAppointmentReason,
      // use the string for "is empty" check
      appointmentDate: appointmentDateStr,
      timeFrom,
      timeTo,
    };
    requiredFields.forEach((field) => {
      const fieldValue = (fieldValues as any)[field];
      if (!fieldValue) {
        if (departmentName === 'Surgery' && (field === 'room' || field === 'table')) {
          return;
        }
        newErrors[field] = `${field} ${tAppointmentForm('fieldIsRequired')}`;
      }
    });    
    if (departmentName === 'Surgery') {
      if (!selectedRoom) {
        newErrors['room'] = tAppointmentForm('roomRequiredSurgery');
      }
      if (!selectedTable) {
        newErrors['table'] = tAppointmentForm('tableRequiredSurgery');
      }
    }

    if (tabIndex === 0 && !isPatientSelected) {
      newErrors['patient'] = tAppointmentForm('pleaseSelectPatient');
    }

    // Enforce personnel selection ONLY for Semen Collection, Pathology, and Admin
    const personnelRequiredDepartments = ['Semen Collection', 'Pathology', 'Admin'];
    const personnelValidationMessages: Record<string, string> = {
      'Semen Collection': tAppointmentForm('pleaseSelectPersonnel'),
      'Pathology': tAppointmentForm('pleaseSelectPathologist'),
      'Admin': tAppointmentForm('pleaseSelectPersonnel'),
    };
    if (personnelRequiredDepartments.includes(departmentName)) {
      if (!selectedPersonnel || selectedPersonnel.id === -1) {
        newErrors['personnel'] = personnelValidationMessages[departmentName];
      }
    }

    if (timeFrom && timeTo && timeTo <= timeFrom) {
      newErrors['timeTo'] = tAppointmentForm('timeToGreaterThanTimeFrom');
    }

    // Check if appointment start time is in the past (minute-level precision)
    if (appointmentDate && timeFrom) {
      const appointmentStartTime = new Date(`${formatDate(appointmentDate)} ${timeFrom}:00`);
      const currentTimeAtMinutePrecision = new Date(currentTime);
      currentTimeAtMinutePrecision.setSeconds(0, 0);

      if (appointmentStartTime < currentTimeAtMinutePrecision) {
        newErrors['timeFrom'] = tAppointmentForm('cannotBookPastTimeSlot');
      }
    }

    // Check if appointment mode is selected
    if (!selectedAppointmentMode) {
      newErrors['appointmentType'] = tAppointmentForm('appointmentTypeRequired');
    }

    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const bookAppointment = (patientData: any, patientId: number | undefined) => {
    showLoader();
    const startDateTime = convertDateToISOWithOffset(
      new Date(`${formatDate(appointmentDate)} ${timeFrom}:00`)
    );
    const endDateTime = convertDateToISOWithOffset(
      new Date(`${formatDate(appointmentDate)} ${timeTo}:00`)
    );
    const payload = {
      user: selectedPersonnel?.id,
      department: selectedDepartment,
      appointment_date: formatDate(appointmentDate),
      start_datetime: startDateTime,
      end_datetime: endDateTime,
      appointment_reason: selectedAppointmentReason,
      ...(Object.keys(patientData || {}).length === 0
        ? { patient: patientId }
        : {
          patient_data: {
            clinic_id: ClinicId,
            first_name: patientData?.first_name,
            last_name: patientData?.last_name,
            middle_name: null,
            date_of_birth: patientData?.date_of_birth,
            blood_group: null,
            gender: patientData?.gender,
            mobile_number: patientData?.mobile_number,
            mobile_number_country_code: patientData?.mobile_number_country_code,
            patient_type: patientData?.patient_type,
            alternate_email: patientData?.alternate_email,
          },
        }),
      ...(patientData?.partner?.first_name && {
        partner_data: {
          clinic_id: ClinicId,
          first_name: patientData.partner.first_name,
          last_name: patientData.partner.last_name,
          middle_name: null,
          date_of_birth: patientData.partner.date_of_birth,
          blood_group: null,
          gender: patientData.partner.gender,
          mobile_number: patientData.partner.mobile_number,
          mobile_number_country_code: patientData.partner.mobile_number_country_code,
          alternate_email: patientData?.partner?.alternate_email,
          // patient_type: patientData.partner.patient_type
        },
      }),
      remark: remark,
      room: null,
      table: null,
      appointment_mode: selectedAppointmentMode || null,
      ...(selectedClinic !== undefined && Number(ClinicId) > 0 && selectedClinic !== Number(ClinicId) && {
        source_clinic_id: selectedClinic,
        checkin_clinic_id: Number(ClinicId),
      }),
    };
    
    
    postBookAppointment(payload)
      .then((response) => {
        addAlert(tAppointmentForm('appointmentBookedSuccess'), 'success');
        onClose();
      })
      .catch((error) => {
        if (error.response) {
          const validationErrors = error.response.data.errors;
          validationErrors.forEach((errorDetail: { detail: any; }) => {
            const errorMessage = errorDetail.detail;
            addAlert(errorMessage, 'error');
          });
        } else {
          addAlert(tAppointmentForm('networkError'), 'error');
        }
      })
      .finally(() => {
        hideLoader();
      });
  };

  const [newPatientData, setNewPatientData] = useState<bookSlotPatientData>({
    firstName: '',
    lastName: '',
    gender: 'FEMALE',
    mobile: '', 
    dob: '',
    email: '',
    mobile_country_code: '',
  });

  const [partnerData, setPartnerData] = useState<PartnerData>({
    firstName: '',
    lastName: '',
    gender: '',
    mobile: '',
    dob: '',
    email: '',
    mobile_country_code: '',
    isPartnerSelected: false, // Manage partner checkbox
  });
  const [errors, setErrors] = useState<ValidationErrors1>({});
  const resetFormFields = () => {
    setPartnerData({
      firstName: '',
      lastName: '',
      gender: 'MALE',
      mobile_country_code: '',
      mobile: '',
      dob: '',
      email: '',
      isPartnerSelected: false,
    });
    setNewPatientData({
      firstName: '',
      lastName: '',
      gender: 'FEMALE',
      mobile_country_code: '',
      mobile: '',
      dob: '',
      email: '',
    });
    setErrors({});
    setFormErrors({
      personnel: '',
      appointmentReason: '',
      remark: ''
    });
    setSelectedPersonnel(undefined);
    setSelectedAppointmentReason(undefined);
    setSelectedRoom(undefined);
    setSelectedTable(undefined);
    setSelectedAppointmentMode('WALK_IN');
  };

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedPatientDetails(null);
    setTabIndex(newValue);
    resetFormFields();
    setInputValue(''); // <-- Reset search input
    setPatients([]);   // <-- Clear patient list
    setSelectedValue(null); // <-- Clear selected patient
    setIsPatientSelected(false); // <-- Reset selection state
  };

  const fetchDepartments = useCallback(() => {
    departmentsByClinic(ClinicId)
      .then((data) => {
        // Filter out the departments that are not in the departmentTabs
        const filterDepartmentList: DepartmentDetail[] = (departmentTabs || []).filter((department) => data.objects.some((dept) => dept.id === department.id)); 
        setDepartmentList(filterDepartmentList);
        console.log('Filtered Departments:', filterDepartmentList);
        
      })
      .catch((error) => {
        console.error('Error fetching departments:', error);
      });
  }, [ClinicId, departmentTabs]);


  const fetchDepartmentsRooms = () => {
    getRooms()
      .then((data) => {
        setRoom(data.objects);
      })
      .catch((error) => {
        console.error('Error fetching departments room:', error);
      });
  };

  const fetchOTtables = (roomID = '') => {
    const query = roomID ? `roomID=${roomID}` : '';
    getOTtables(query)
      .then((data) => {
        setTable(data.objects);
      })
      .catch((error) => {
        console.error('Error fetching OT tables:', error);
      });
  };

  const fetchAppointmentReasons = useCallback(() => {
    appointmentReasons({ clinicId: Number(ClinicId), departmentId: Number(selectedDepartment) })
      .then((data) => {
        setAppointmentReasonsList(data.objects);
      })
      .catch((error) => {
        console.error('Error fetching appointment reasons:', error);
      });
  }, [ClinicId, selectedDepartment]);

  const fetchPersonnelByRole = useCallback(() => {
    getUsersByClinic(ClinicId, selectedDepartment.toString())
      .then((res: any) => {
        const personnels = res?.objects ?? [];
        setRoleList(personnels);
      })
      .catch((error) => {
        console.error('Error fetching working hours:', error);
      });

  }, [selectedDepartment, ClinicId]);


  const fetchPatientDetails = (id: string) => {
    getPatientDetails(id)
      .then((details) => {
        setSelectedPatientDetails(details);
        if (details.partner) {
          setCheckboxState({
            patient: true, // Patient is selected
            partner: true, // Check partner if present
            oocyteDonor: false,
            spermDonor: false,
            surrogate: false
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching patient details:', error);
      });
  };

  const validateFields = () => {
    const  formErrors1: ValidationErrors1 = {};
    if (!newPatientData.firstName) formErrors1.firstName = tAppointmentForm('firstNameRequired');
    if (!newPatientData.lastName) formErrors1.lastName = tAppointmentForm('lastNameRequired');
    if (!newPatientData.gender) formErrors1.gender = tAppointmentForm('genderRequired');
    if (!newPatientData.mobile) formErrors1.mobile = tAppointmentForm('mobileRequired');
    if (!newPatientData.dob) formErrors1.dob = tAppointmentForm('dobRequired');
    if (!newPatientData.email) formErrors1.email = tAppointmentForm('emailRequired');
    if (!newPatientData.mobile_country_code) formErrors1.mobile_country_code = tAppointmentForm('mobileCountryCodeRequired');
    if (!newPatientData.email) {
      formErrors1.email = tAppointmentForm('emailRequired');
    } else if (!validateEmail(newPatientData.email)) {
      formErrors1.email = tAppointmentForm('invalidEmailFormat');
    }

    if (checkboxState.partner) {
      if (!partnerData.firstName) formErrors1.partnerFirstName = tAppointmentForm('partnerFirstNameRequired');
      if (!partnerData.lastName) formErrors1.partnerLastName = tAppointmentForm('partnerLastNameRequired');
      if (!partnerData.gender) formErrors1.partnerGender = tAppointmentForm('partnerGenderRequired');
      if (!partnerData.mobile) formErrors1.partnerMobile = tAppointmentForm('partnerMobileRequired');
      if (!partnerData.dob) formErrors1.partnerDob = tAppointmentForm('partnerDobRequired');
      if (!partnerData.email) formErrors1.partnerEmail = tAppointmentForm('partnerEmailRequired');
      if (!partnerData.mobile_country_code) formErrors1.partner_mobile_country_code = tAppointmentForm('mobileCountryCodeRequired');

      if (!partnerData.email) {
        formErrors1.partnerEmail = tAppointmentForm('partnerEmailRequired');
      } else if (!validateEmail(partnerData.email)) {
        formErrors1.partnerEmail = tAppointmentForm('invalidEmailFormat');
      }
    }


    setErrors(formErrors1);

    return Object.keys(formErrors1).length === 0;
  };

  useEffect(() => {
    const updatedDate = convertToDate(slotDate || new Date());
    setAppointmentDate(updatedDate);
    setAppointmentDateStr(formatDate(updatedDate));

    // if view is month -> use current time, else keep slot time
    if (view === 'month') {
      const now = new Date();
      setTimeFrom(formatTime(now));
      setTimeTo(formatTime(addMinutes(now, 15)));
    } else {
      setTimeFrom(formatTime(updatedDate));
      setTimeTo(formatTime(addMinutes(updatedDate, 15)));
    }
  }, [slotDate, view]);

  useEffect(() => {
    setSelectedDepartment(slotDepartment || '');
  }, [slotDepartment]);

  useEffect(() => {
    let abortController: AbortController | null = null;
    // Only fetch patients when on existing patient tab (tabIndex === 0)
    if (tabIndex === 0 && debouncedSearchTerm) {
      setLoading(true);
      abortController = new AbortController();
      const query = `limit=50&search=${debouncedSearchTerm}`;
      const clinicIdToUse = selectedClinic ? String(selectedClinic) : ClinicId;
      fetchPatientFullList(query, clinicIdToUse, { signal: abortController.signal })
        .then((response) => {
          setPatients(response.objects as Patient[]);
          setError('');
        })
        .catch((err) => {
          if (err.name !== 'AbortError') {
            console.error('Error fetching patients:', err);
            setError('Failed to fetch patients');
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setPatients([]);
    }
    return () => {
      if (abortController) {
        abortController.abort();
      }
    };
  }, [debouncedSearchTerm, ClinicId, tabIndex, selectedClinic]);

  const fetchGender = () => {
    getGender()
      .then((res) => {
        setGenders(res.objects);
      })
      .catch((error) => {
        console.error('Error fetching gender data:', error);
      });
  };
  
  const fetchCountryCodes = () => {
    getcountrycode()
      .then((res) => {
        setCountryCodes(res.data);
        setFilteredCountryCodes(res.data);
      })
      .catch((error) => {
        console.error('Error fetching country code data:', error);
      });
  };  

  const handleInputChange = (event: any, value: string, reason: string) => {
    if (reason === 'input') {
      const filtered = countryCodes.filter(country =>
        country.name.toLowerCase().startsWith(value.toLowerCase()) ||
        country.dial_code.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCountryCodes(filtered);
    }
  };

  useEffect(() => {
    if (open) {
      fetchDepartments();
      fetchAppointmentReasons();
      // OLD LOGIC: fetchPersonnelByRole was used to get all users, now getUsersByClinicAndTime returns all users with is_available flag
      // fetchPersonnelByRole();
      fetchGender();
      fetchCountryCodes();
      getClinicList()
        .then((res) => {
          setClinicList(res.objects);
        })
        .catch((error) => {
          console.error('Error fetching clinic list:', error);
        });
    }
  }, [open, fetchDepartments, fetchAppointmentReasons]);

  const fetchPersonnelByRoleAndTime = useCallback(() => {
    // Only call API if we have valid time values
    if (!timeFrom || !timeTo) {
      return;
    }
    const startDateTime = formatDateToISOWithOffsetFilter( new Date(`${formatDate(appointmentDate)} ${timeFrom}:00`));
    const endDateTime = formatDateToISOWithOffsetFilter( new Date(`${formatDate(appointmentDate)} ${timeTo}:00`));
    getUsersByClinicAndTime(ClinicId, selectedDepartment.toString(), startDateTime, endDateTime)
      .then((res: any) => {
        const personnels = res?.objects ?? [];
        console.log(personnels);
        
        // NEW LOGIC: API now returns all users with is_available flag
        setRoleList(personnels);
        // OLD LOGIC: setAvailableRoleList(personnels);
      })
      .catch((error) => {
        console.error('Error fetching working hours:', error);
      });
  }, [selectedDepartment, ClinicId, appointmentDate, timeFrom, timeTo]);

  useEffect(() => {
    if (open && timeFrom && timeTo && selectedDepartment) {
      fetchPersonnelByRoleAndTime();
    }
  }, [open, timeFrom, timeTo, selectedDepartment, appointmentDate, ClinicId, fetchPersonnelByRoleAndTime]);

  useEffect(() => {
    if (open) {
      setSelectedPatientDetails(null);
      setSelectedPersonnel(undefined);
      setIsPatientSelected(false);
      setIsFormSubmitted(false);
      setSelectedAppointmentReason(undefined);
      setRemark('');
      setSelectedValue(null);
      setInputValue('');
      // Set default clinic to parent clinic from ClinicProvider
      setSelectedClinic(ClinicId ? Number(ClinicId) : undefined);

      resetFormFields();
    }
  }, [open, ClinicId]);

  const updateTimeToBasedOnReason = (value: string, selectedAppointmentReason: number | undefined) => {
    let duration = 15; // Default duration in minutes
    if (selectedAppointmentReason) {
      const reason = appointmentReasonsList.find(({ id }) => id === selectedAppointmentReason);
      if (reason && reason.default_duration) {
        duration = reason.default_duration;
      }
    }
    const timeFromDate = new Date(`${formatDate(new Date())}T${value}:00`);
    const timeToFormatted = new Date(timeFromDate.getTime() + duration * 60000)
      .toTimeString()
      .slice(0, 5);
    setTimeTo(timeToFormatted);
  };

  const handleChange = (field: string, value: any) => {
    if (field === 'remark') {
      setRemark(value);
      return;
    }

    switch (field) {
    case 'department':
      setSelectedDepartment(value);

      // Clear selected personnel when department changes
      setSelectedPersonnel(undefined);
      setSelectedAppointmentReason(undefined);

      if (formErrors.department) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          department: '',
        }));
      }
      if(handleTabChange){
        const departmentTabObject = departmentList.find((department) => department.id === value);
        handleTabChange(departmentTabObject);
      }
      break;
    case 'personnel':
      setSelectedPersonnel(value);
      if (formErrors.personnel) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          personnel: '',
        }));
      }
      break;
    case 'appointmentReason':
      setSelectedAppointmentReason(value);
      if (formErrors.appointmentReason) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          appointmentReason: '',
        }));
      }
      break;
    case 'appointmentDate': {
      // always store raw string so typing is not lost
      setAppointmentDateStr(value);

      if (value) {
        const parsed = new Date(value);
        if (!Number.isNaN(parsed.getTime())) {
          setAppointmentDate(parsed);
        }
      }

      if (formErrors.appointmentDate) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          appointmentDate: '',
        }));
      }
      break;
    }
    case 'timeFrom':
      setTimeFrom(value);
      updateTimeToBasedOnReason(value, selectedAppointmentReason);

      if (formErrors.timeFrom) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          timeFrom: '',
        }));
      }
      break;
    case 'timeTo':
      setTimeTo(value);
      if (formErrors.timeTo) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          timeTo: '',
        }));
      }
      break;

    case 'room':
      setSelectedRoom(value);
      fetchOTtables(value);
      if (formErrors.room) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          room: '',
        }));
      }
      break;
    case 'table':
      setSelectedTable(value);
      if (formErrors.table) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          table: '',
        }));
      }
      break;
    default:
      break;
    }
  };

  const handleCheckboxChange = (event: { target: { name: string; checked: boolean } }) => {
    const { name, checked } = event.target;

    setCheckboxState((prevState: any) => {
      let newState = { ...prevState, [name]: checked };

      if (name === 'patient' && checked) {
        newState = {
          patient: true,
          partner: prevState.partner,
          spermDonor: false,
          oocyteDonor: false,
          surrogate: false,
        };
      } else if (name === 'partner' && checked) {
        newState = {
          ...newState,
          patient: true,
        };
      } else if (checked) {
        newState = {
          patient: false,
          partner: false,
          spermDonor: false,
          oocyteDonor: false,
          surrogate: false,
          [name]: true,
        };
      }


      // Handle gender logic
      if (checked) {
        if (name === 'spermDonor') {
          setNewPatientData((prev: any) => ({
            ...prev,
            gender: 'MALE',
          }));
          setIsGenderDisabled(true);
        } else if (name === 'oocyteDonor' || name === 'surrogate') {
          setNewPatientData((prev: any) => ({
            ...prev,
            gender: 'FEMALE',
          }));
          setIsGenderDisabled(true);
        } else {
        // For patient/partner
          setIsGenderDisabled(false);
        }
      } else {
      // If unchecked any donor option
        setIsGenderDisabled(false);
      }


      return newState;
    });
  };
  


  const getRegistrationTypeValue = (type: string) =>
    registrationTypesEnum.find(item => item.value === type)?.value;

  const updatePatientType = useCallback(() => {
    const { patient, partner, oocyteDonor, spermDonor, surrogate } = checkboxState;
    if (patient && partner) {
      setPatientType(getRegistrationTypeValue('PATIENT_COUPLE') ?? 'PATIENT_COUPLE');
    } else if (oocyteDonor) {
      setPatientType(getRegistrationTypeValue('OOCYTE_DONOR') ?? 'OOCYTE_DONOR');
    } else if (spermDonor) {
      setPatientType(getRegistrationTypeValue('SPERM_DONOR') ?? 'SPERM_DONOR');
    } else if (surrogate) {
      setPatientType(getRegistrationTypeValue('SURROGATE') ?? 'SURROGATE');
    } else if (partner) {
      setPatientType(getRegistrationTypeValue('PATIENT_COUPLE') ?? 'PATIENT_COUPLE');
    } else {
      setPatientType(getRegistrationTypeValue('PATIENT_SINGLE') ?? 'PATIENT_SINGLE');
    }
  }, [checkboxState]);
  

  useEffect(() => {
    updatePatientType();
  }, [updatePatientType]);

  useEffect(() => {
    if(departmentName === 'Surgery'){
      fetchDepartmentsRooms();
    }

  }, [departmentName]);

  useEffect(() => {
    if (newPatientData.gender === 'FEMALE' || newPatientData.gender === 'MALE') {
      setPartnerData((prevData) => ({
        ...prevData,
        gender: newPatientData.gender === 'FEMALE' ? 'MALE' : 'FEMALE',
      }));
    }
  }, [newPatientData.gender]);

  const handlePatientOrPartnerChange = <T extends bookSlotPatientData>(
    field: keyof T,
    value: string,
    isPartner: boolean
  ) => {

    // Email Validation
    if (field === 'email') {
      if (/\s/.test(value)) {
        return; // Stop further execution if a space is entered
      }
    }


    // Update the correct state
    if (isPartner) {
      setPartnerData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    } else {
      setNewPatientData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
    

    if (errors[field as keyof ValidationErrors1]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field as keyof ValidationErrors1]: '', // Clear error for this field
      }));
    }
  };


  const handleOpenConfirmationModal = () => {
    let isValid = true;

    if (tabIndex === 1) {
      // Validate new patient fields
      const newPatientValid = validateFields(); // Validate fields specific to new patient
      isValid = isValid && newPatientValid; // Combine validity with existing checks
    }

    // Always validate the overall form regardless of tabIndex
    const formValid = validateForm(); // Validate the general form
    isValid = isValid && formValid; // Combine validity with new patient checks
    const timeDiff = timeDifference(timeFrom, timeTo);
  
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);


    if (formatDate(appointmentDate) < formatDate(yesterday)) {
      addAlert('You cannot select a date earlier than yesterday for the appointment.', 'error');
      return;
    } 

    if (timeDiff < 5 || timeDiff > 300) {
      addAlert(tAppointmentForm('timeSlotRangeError'), 'error');
      return;
    } 

    if (isValid) {
      setOpenConfirmationModal(true);
    } else {
      console.error('Form has errors!', errors);
    }
  };

  const handleSaveAppointment = () => {
    const payload = {
      first_name: newPatientData.firstName,
      last_name: newPatientData.lastName,
      gender: newPatientData.gender,
      mobile_number: newPatientData.mobile,
      date_of_birth: newPatientData.dob,
      patient_type: patientType,
      // additional_info: {
      alternate_email: newPatientData.email,
      clinic:ClinicId,
      mobile_number_country_code: newPatientData.mobile_country_code,
      reason_for_visit: selectedAppointmentReason,
      // },

      ...(checkboxState.partner && {
        partner: {
          first_name: partnerData.firstName,
          last_name: partnerData.lastName,
          date_of_birth: partnerData.dob,
          gender: partnerData.gender,
          alternate_email: partnerData.email,
          clinic:ClinicId,
          mobile_number: partnerData.mobile,
          mobile_number_country_code: partnerData.mobile_country_code,
          patient_type: patientType,
        },
      }),
    };
    if (tabIndex === 1) {
      bookAppointment(payload, 0);
    } else if (tabIndex === 0) {
      bookAppointment({}, selectedPatientDetails?.id);
    }
  };

  const getPatientName = () => {
    if (tabIndex === 1 && newPatientData.firstName && newPatientData.lastName) {
      return `${newPatientData.firstName} ${newPatientData.lastName}`;
    }
    if (selectedPatientDetails?.first_name && selectedPatientDetails?.last_name) {
      return `${selectedPatientDetails.first_name} ${selectedPatientDetails.last_name}`;
    }
    return 'Patient';
  };

  const get21YearsAgoDate = () => {
    const today = new Date();
    // return new Date(today.getFullYear(), today.getMonth(), today.getDate());    //EMR-2991 removed this validation as per discuss with pratik 
    return new Date(today.getFullYear() - 21, today.getMonth(), today.getDate()); //removed this validation as per discuss with sonali
  };

  const defaultDate = formatDate(get21YearsAgoDate());

  


  const handleClosePopup = () => {
    // setIsPopupOpen(false);
    // setSelectedPatientDetails(null);
    setAppointmentDate(new Date());
    // setTimeFrom(formatTime(new Date()));
    // setTimeTo(formatTime(addMinutes(new Date(), 15)));
    setOpenConfirmationModal(false);
    // resetFormFields();    
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };

  return (
    <Dialog
      key={i18n.language}
      open={open}
      onClose={(event, reason) => {
        handleClosePopup();
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      fullWidth maxWidth='lg'
      PaperProps={{  sx: {  borderRadius: '12px', width: '55%',  minWidth: '700px',},  }}
    >
      <DialogTitle sx={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1px' }}>
          <span>{tAppointmentForm('appointmentTitle')}</span>
          <IconButton
            edge='end'
            color="inherit"
            onClick={onClose}
            aria-label="close"
            className={styles.floatEnd}
          >
            <More />
          </IconButton>
        </div>
        <Typography variant="body2" color="textSecondary" sx={{ marginTop: '0px' }}>
          {tabIndex === 0
            ? tAppointmentForm('existingPatientSubtitle')
            : tAppointmentForm('newPatientSubtitle')}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <div className="px-0">
          <Tabs
            value={tabIndex}
            onChange={handleChangeTab}
            aria-label="registration tabs"
            variant="fullWidth"
            style={{ borderBottom: '2px solid #f2f2f2', fontWeight: '800' }}
            TabIndicatorProps={{ sx: { backgroundColor: 'rgba(225, 126, 97, 1)', height: '2px' } }}
            sx={{
              '& .MuiTab-root': {
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontWeight: '400',
                lineHeight: '22px',
                textAlign: 'left',
                textTransform: 'none',
                width: '100%',
                color: 'rgba(141, 152, 162, 1)',
              },
              '& .Mui-selected': {
                color: '#E17E61',
                fontWeight: '800',
              },
              mb: 2,
            }}
          >
            <Tab label={tAppointmentForm('existingPatientTab')} />
            <Tab label={tAppointmentForm('newPatientTab')} />
          </Tabs>


          <Grid2 container alignItems='center' spacing={2} sx={{ mb: 3}}>
            <Grid2 size={{xs: tabIndex === 1 ? 12 : 3}} >
              {/* Patient Radio Button */}
              <FormControl>
                <RadioGroup>
                  <FormControlLabel
                    value="PATIENT"
                    control={
                      <Radio
                        name="patient"
                        checked={checkboxState.patient}
                        onChange={handleCheckboxChange}
                        sx={{
                          pl:2,
                          color: '#232323',
                          '&.Mui-checked': {
                            color: '#4CAF50',
                          },
                        }}
                      />
                    }
                    label={tAppointmentForm('patientLabel')}
                  />

                </RadioGroup>
              </FormControl>

              {(checkboxState.patient && tabIndex === 1) && (
                <FormControlLabel
                  control={
                    <Checkbox
                      name="partner"
                      checked={checkboxState.partner}
                      onChange={handleCheckboxChange}
                      sx={{
                        color: '#232323',
                        '&.Mui-checked': {
                          color: '#4CAF50',
                        },
                      }}
                    />
                  }
                  label={tAppointmentForm('partnerLabel')}
                />
              )}

              {tabIndex === 1 && ( 
                <FormControl>
                  <RadioGroup>
                    <Stack direction="row">
                      {/* Sperm Donor Radio Button */}
                      <FormControlLabel
                        value="SPERM_DONOR"
                        control={
                          <Radio
                            name="spermDonor"
                            checked={checkboxState.spermDonor}
                            onChange={handleCheckboxChange}
                            sx={{
                              color: '#232323',
                              '&.Mui-checked': {
                                color: '#4CAF50',
                              },
                            }}
                          />
                        }
                        label={tAppointmentForm('spermDonorLabel')}
                      />
                      {/* Oocyte Donor Radio Button */}
                      <FormControlLabel
                        value="OOCYTE_DONOR"
                        control={
                          <Radio
                            name="oocyteDonor"
                            checked={checkboxState.oocyteDonor}
                            onChange={handleCheckboxChange}
                            sx={{
                              color: '#232323',
                              '&.Mui-checked': {
                                color: '#4CAF50',
                              },
                            }}
                          />
                        }
                        label={tAppointmentForm('oocyteDonorLabel')}
                      />
                      {/* Surrogate Radio Button */}
                      <FormControlLabel
                        value="SURROGATE"
                        control={
                          <Radio
                            name="surrogate"
                            checked={checkboxState.surrogate}
                            onChange={handleCheckboxChange}
                            sx={{
                              color: '#232323',
                              '&.Mui-checked': {
                                color: '#4CAF50',
                              },
                            }}
                          />
                        }
                        label={tAppointmentForm('surrogateLabel')}
                      />
                    </Stack>
                  </RadioGroup>
                </FormControl>
              )}
            </Grid2>

            {/* Clinic Dropdown */}
            {tabIndex === 0 && (
              <Grid2 size={{xs:3}}>
                <FormControl fullWidth size="small">
                  <Autocomplete
                    id="clinic-select"
                    options={clinicList}
                    getOptionLabel={(option) => option.name || ''}
                    value={clinicList.find((clinic) => clinic.id === selectedClinic) || null}
                    onChange={(_e, clinicNewValue: Clinic | null) => setSelectedClinic(clinicNewValue?.id ?? undefined)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label={tAppointmentForm('clinicLabel') || 'Clinic'}
                        slotProps={{ inputLabel: { shrink: true } }}
                        sx={{
                          height: '48px',
                          '& .MuiOutlinedInput-root': {
                            height: '48px',
                          },
                        }}
                      />
                    )}
                    disabled={clinicList.length === 0}
                  />
                </FormControl>
              </Grid2>
            )}

            {tabIndex === 0 && (
              <Grid2 size={{xs:6}}>
                <Autocomplete
                  options={patients}
                  getOptionLabel={(option) => {
                    if (!option) return '';
                    const mrn = option.medical_record_no || '';
                    const first = option.first_name || '';
                    const last = option.last_name || '';
                    const label = `${mrn} | ${first} ${last}`.trim();
                    return label !== '| ' ? label : 'Unknown Patient';
                  }}
                  inputValue={inputValue}
                  value={selectedValue}
                  open={isPatientDropdownOpen && inputValue.trim() !== '' && (patients.length > 0 || loading)}
                  onOpen={() => setIsPatientDropdownOpen(true)}
                  onClose={() => setIsPatientDropdownOpen(false)}
                  loading={loading}
                  loadingText={tAppointmentForm('searchingPatients') || 'Searching...'}
                  noOptionsText={tAppointmentForm('noPatientFound') || 'No patients found'}
                  onInputChange={(event, newInputValue, reason) => {
                    setInputValue(newInputValue);
                    // Only trigger search when user is typing (reason === 'input'), not when autocomplete clears/resets the value
                    if (reason === 'input') {
                      setPatientSearchTerm(newInputValue);
                      setIsPatientDropdownOpen(true);
                    }
                    if (newInputValue.trim() === '') {
                      setPatients([]); // clears the dropdown options
                      setSelectedValue(null);
                      setIsPatientSelected(false);
                      setSelectedPatientDetails(null); // Clear previous visits when input is cleared
                      setIsPatientDropdownOpen(false);
                    }
                  }}
                  onChange={(event, newValue) => {
                    setSelectedValue(newValue);
                    setIsPatientDropdownOpen(false);
                    if (newValue) {
                      fetchPatientDetails(String(newValue.id));
                      setIsPatientSelected(true);
                      setPatients([]); // Clear patients list to close dropdown after selection
                    } else {
                      setIsPatientSelected(false);
                      setPatients([]);
                      setSelectedPatientDetails(null); // Clear previous visits when patient is cleared
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={tAppointmentForm('selectPatientOrPartnerLabel')}
                      placeholder={tAppointmentForm('searchPatientOrPartnerPlaceholder')}
                      variant="outlined"
                      error={isFormSubmitted && !isPatientSelected}
                      InputLabelProps={{
                        shrink: inputFocused || !!inputValue || !!selectedValue,
                      }}
                      sx={{
                        height: '48px',
                        '& .MuiOutlinedInput-root': {
                          height: '48px',
                          paddingLeft: '40px', // 👈 ensures label/input text doesn't overlap the icon
                        },
                        
                        '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                          left: '30px', // Only move label when not shrunk
                        },
                      }}
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start" sx={{ position: 'absolute', left: 10 }}>
                              <SearchIcon style={{ height: '90%', width: '90%' }} />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <>
                              {loading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps?.endAdornment}
                            </>
                          ),
                        },
                      }}
                      onFocus={() => setInputFocused(true)}
                      onBlur={() => setInputFocused(false)}
                    />
                  )}
                />

              </Grid2>
            )}
          </Grid2>

          <ThemeProvider theme={theme}>
            <div className={styles.basicInfoContainer}>
              <Grid2 container spacing={2}>
                {tabIndex === 1 && (
                  <>
                    {/* New Patient Fields */}
                    <Grid2 size={{xs:4}}>
                      <TextField
                        fullWidth
                        size="small"
                        label={LabeledWithAsterisk(tAppointmentForm('firstNameLabel'), true)}
                        value={newPatientData.firstName}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Only update state if the value contains alphabetic characters
                          if (/^[a-zA-Z]*$/.test(value) || value === '') {
                            handlePatientOrPartnerChange('firstName', value, false);
                          }
                        }}
                        error={!!errors.firstName}  // Use errors instead of formErrors1
                        // helperText={errors.firstName} // Use errors instead of formErrors1
                      />
                    </Grid2>

                    <Grid2 size={{xs:4}}>
                      <TextField
                        fullWidth
                        size="small"
                        label={LabeledWithAsterisk(tAppointmentForm('lastNameLabel'), true)}
                        value={newPatientData.lastName}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z]*$/.test(value) || value === '') {
                            handlePatientOrPartnerChange('lastName', value, false); // false for new patient
                          }
                        }}
                        error={!!errors.lastName}  // Use errors instead of formErrors1
                        // helperText={errors.lastName} // Use errors instead of formErrors1
                      />
                    </Grid2>

                    <Grid2 size={{xs:4}}>
                      <FormControl fullWidth size="small" error={!!errors.gender}>
                        <InputLabel id="gender-label">{LabeledWithAsterisk(tAppointmentForm('sexAssignedAtBirthLabel'), true)}</InputLabel>
                        {/* <Select
                          labelId="gender-label"                          
                          label={LabeledWithAsterisk(tAppointmentForm('sexAssignedAtBirthLabel'), true)}
                          value={newPatientData.gender}
                          onChange={(e) => handlePatientOrPartnerChange('gender', e.target.value, false)} // false for new patient
                        > */}
                        <Select
                          labelId="gender-label"
                          label={LabeledWithAsterisk('Sex Assigned at Birth', true)}
                          value={newPatientData.gender}
                          onChange={(e) => handlePatientOrPartnerChange('gender', e.target.value, false)}
                          disabled={isGenderDisabled}
                        >

                          {genders.map((gender) => (
                            <MenuItem key={gender.name} value={gender.name}>
                              {toTitleCase(gender.name)}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl> 
                    </Grid2>
 
                    <Grid2 size={{xs:4}}>
                      <Grid2 container spacing={1}>
                        <Grid2 size={{xs:5}}>
                          <FormControl fullWidth variant="outlined" error={!!errors.mobile}>
                            <Autocomplete
                              options={filteredCountryCodes}
                              getOptionLabel={(option) => newPatientData.mobile_country_code === option.dial_code ? option.dial_code : `${option.name} (${option.dial_code})`} // Show only dial_code when selected, name + dial_code in dropdown
                              value={filteredCountryCodes.find(country => country.dial_code === newPatientData.mobile_country_code) || null} // Use filteredCountryCodes for value
                              onChange={(event, newValue) => {
                                handlePatientOrPartnerChange('mobile_country_code', newValue?.dial_code || '', false);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={LabeledWithAsterisk(tAppointmentForm('countryCodeLabel'), true)}
                                  variant="outlined"
                                  autoComplete='off'
                                  error={!!errors.mobile_country_code}
                                  slotProps={{
                                    input: {
                                      ...params.InputProps,
                                      endAdornment: null,
                                    },
                                  }}
                                />
                              )}
                              renderOption={(props, option) => (
                                <li {...props} style={{ fontSize: '0.8rem' }}>
                                  {`${option.name} (${option.dial_code})`}
                                </li>
                              )}
                              onInputChange={handleInputChange} // Use the new input change handler
                              isOptionEqualToValue={(option, value) => option.dial_code === value.dial_code && option.name === value.name} // Match both name and dial_code
                              sx={{ width: '100%', height: '56px',
                                '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
                                  width: 'auto',
                                  minWidth: '3.5rem',
                                  maxWidth: '4rem' }
                              }}
                            />
                          </FormControl>
                        </Grid2>

                        <Grid2 size={{xs:7}}>
                          <TextField
                            fullWidth
                            size="small"                            
                            label={LabeledWithAsterisk(tAppointmentForm('mobileLabel'), true)}
                            value={newPatientData.mobile}
                            // onChange={(e) => handlePatientOrPartnerChange('mobile', e.target.value, false)}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value) || value === '') {
                                handlePatientOrPartnerChange('mobile', value, false);
                              }
                            }}
                            error={!!errors.mobile}
                            type="tel"
                            slotProps={{htmlInput: { maxLength: 11 }}}
                          />
                        </Grid2>
                      </Grid2>
                    </Grid2>

                    <Grid2 size={{xs:4}}>
                      <TextField
                        fullWidth
                        size="small"
                        label={LabeledWithAsterisk(tAppointmentForm('dobLabel'), true)}
                        type="date"
                        value={newPatientData.dob}
                        onChange={(e) => handlePatientOrPartnerChange('dob', e.target.value, false)}
                        error={!!errors.dob}  // Use errors instead of formErrors                       
                        slotProps={{htmlInput:{max: defaultDate}, inputLabel:{shrink:true}}} // Set max date to 21 years ago
                      />
                    </Grid2>

                    <Grid2 size={{xs:4}}>
                      <TextField
                        fullWidth
                        size="small"
                        label={LabeledWithAsterisk(tAppointmentForm('emailLabel'), true)}
                        value={newPatientData.email}
                        onChange={(e) => handlePatientOrPartnerChange('email', e.target.value, false)}
                        error={!!errors.email}
                        // helperText={errors.email} // Use errors instead of formErrors1
                      />
                    </Grid2>

                    {/* Partner Fields */}

                    {/* Conditionally Render Partner Fields */}
                    {checkboxState.partner && (
                      <>
                        <Grid2 size={{xs:4}}>
                          <TextField
                            fullWidth
                            size="small"
                            id="partnerFirstName"
                            label={LabeledWithAsterisk(tAppointmentForm('partnerFirstNameLabel'), true)}
                            variant="outlined"
                            value={partnerData.firstName}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^[a-zA-Z]*$/.test(value) || value === '') {
                                handlePatientOrPartnerChange('firstName', value, true); // true for partner
                              }
                            }}

                            error={!!errors.partnerFirstName}
                          />
                        </Grid2>

                        <Grid2 size={{xs:4}}>
                          <TextField
                            fullWidth
                            size="small"
                            id="partnerLastName"
                            label={RequiredLabel(tAppointmentForm('partnerLastNameLabel'), true)}
                            variant="outlined"
                            value={partnerData.lastName}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^[a-zA-Z]*$/.test(value) || value === '') {
                                handlePatientOrPartnerChange('lastName', value, true); // true for partner
                              }
                            }}
                            error={!!errors.partnerLastName}
                          />
                        </Grid2>

                        <Grid2 size={{xs:4}}>
                          <FormControl fullWidth size="small" error={!!errors.partnerGender}> {/* Show error state */}
                            <InputLabel id="partner-gender-label">{RequiredLabel(tAppointmentForm('sexAssignedAtBirthLabel'), true)}</InputLabel>
                            <Select
                              labelId="partner-gender-label"
                              id="partnerGender"
                              label={RequiredLabel(tAppointmentForm('sexAssignedAtBirthLabel'), true)}
                              value={partnerData.gender}
                              onChange={(e) => handlePatientOrPartnerChange('gender', e.target.value, true)} // true for partner
                            >
                              {genders.map((gender) => (
                                <MenuItem key={gender.name} value={gender.name}>
                                  {toTitleCase(gender.name)}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid2>

                        <Grid2 size={{xs:4}}>
                          <Grid2 container spacing={1}>
                            <Grid2 size={{xs:5}}>
                              <FormControl fullWidth variant="outlined" error={!!errors.partnerMobile}>
                                <Autocomplete
                                  options={filteredCountryCodes} // Use the filtered country codes for partner as well
                                  getOptionLabel={(option) => partnerData.mobile_country_code === option.dial_code ? option.dial_code : `${option.name} (${option.dial_code})`} // Show only dial_code when selected, name + dial_code in dropdown
                                  value={filteredCountryCodes.find(country => country.dial_code === partnerData.mobile_country_code) || null} // Use filteredCountryCodes for value
                                  onChange={(event, newValue) => {
                                    handlePatientOrPartnerChange('mobile_country_code', newValue?.dial_code || '', true); // Set true for partner
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={RequiredLabel(tAppointmentForm('countryCodeLabel'), true)}
                                      autoComplete='off'
                                      variant="outlined"
                                      error={!!errors.partner_mobile_country_code}
                                      slotProps={{
                                        input: {
                                          ...params.InputProps,
                                          endAdornment: null, // Remove the dropdown arrow icon
                                        },
                                      }}
                                    />
                                  )}
                                  renderOption={(props, option) => (
                                    <li {...props} style={{ fontSize: '0.8rem' }}>
                                      {`${option.name} (${option.dial_code})`}
                                    </li>
                                  )}
                                  onInputChange={handleInputChange} // Use the new input change handler
                                  isOptionEqualToValue={(option, value) => option.dial_code === value.dial_code && option.name === value.name} // Match both name and dial_code
                                  sx={{ width: '100%', height: '56px' }}
                                />
                              </FormControl>
                            </Grid2>

                            <Grid2 size={{xs:7}}>
                              <TextField
                                fullWidth
                                size="small"
                                id="partnerMobile"
                                label={RequiredLabel(tAppointmentForm('mobileLabel'), true)}
                                variant="outlined"
                                value={partnerData.mobile}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value) || value === '') { // Allow only digits and empty string
                                    handlePatientOrPartnerChange('mobile', value, true); // Set true for partner
                                  }
                                }}
                                error={!!errors.partnerMobile}
                                type="tel"
                                slotProps={{ htmlInput: { maxLength : 11 }}}
                              />
                            </Grid2>
                          </Grid2>
                        </Grid2>

                        <Grid2 size={{xs:4}}>
                          <TextField
                            fullWidth
                            size="small"
                            id="partnerDob"
                            label={RequiredLabel(tAppointmentForm('dobLabel'), true)}
                            type="date"                            
                            variant="outlined"
                            value={partnerData.dob}
                            onChange={(e) => handlePatientOrPartnerChange('dob', e.target.value, true)}
                            error={!!errors.partnerDob}                           
                            slotProps={{ htmlInput:{max: defaultDate}, inputLabel:{shrink:true} }}
                          />
                        </Grid2> 

                        <Grid2 size={{xs:4}}>
                          <TextField
                            fullWidth
                            size="small"
                            id="partnerEmail"                            
                            label={RequiredLabel(tAppointmentForm('emailLabel'), true)}
                            variant="outlined"
                            value={partnerData.email}
                            onChange={(e) => handlePatientOrPartnerChange('email', e.target.value, true)}
                            error={!!errors.partnerEmail}
                          />
                        </Grid2>
                      </>
                    )}
                  </>
                )}

                {tabIndex === 0 && isPatientSelected && selectedPatientDetails && (
                  <PatientDetails selectedPatientDetails={selectedPatientDetails} />
                )}


                {/* Common Fields */}
                <Grid2 size={{xs:6, sm:4, lg:4}}>
                  <FormControl fullWidth size="small" error={!!formErrors.department}>
                    {/* <InputLabel id="department-label">{RequiredLabel('Department', true)}</InputLabel>
                    <Select
                      labelId="department-label"
                      id="department-select"
                      value={departmentList.find((department) => department.id === selectedDepartment) || undefined}
                      onChange={(e) => handleChange('department', e.target.value)}
                      label={RequiredLabel('Department', true)}
                      disabled={departmentList.length === 0}
                      IconComponent={slotDepartment ? () => null : undefined}
                      endAdornment={<ArrowDropDownIcon/>}
                    >
                      {departmentList.map((department) => (
                        <MenuItem key={department.id} value={department.id}>
                          {department.name}
                        </MenuItem>
                      ))}
                    </Select> */}
                    <Autocomplete
                      id="department-select"
                      options={departmentList}
                      getOptionLabel={(option) => option.name_label || option.name}
                      value={
                        departmentList.find((department) => department.id === selectedDepartment) ||
                        { id: Number(selectedDepartment), name: departmentName, name_label: departmentName, clinic__name: ClinicId, tenant__name: '' }
                      }
                      onChange={(_e, departmentNewValue: DepartmentDetail | null) => handleChange('department', departmentNewValue?.id ?? undefined)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={RequiredLabel(tAppointmentForm('departmentLabel'), true)}
                          error={!!formErrors.department}
                          slotProps={{ inputLabel: { shrink: true } }}
                        />
                      )}
                      disabled={departmentList.length === 0}
                      disableClearable
                    />
                  </FormControl>
                </Grid2>

                <Grid2 size={{xs:6, sm:4, lg:4}}>
                  <FormControl fullWidth size="small" error={!!formErrors.personnel}>
                    {/* <InputLabel>Personnel *</InputLabel> */}
                    <Autocomplete
                      options={sortedRoleList}
                      getOptionLabel={(option: UserBasic) => `${option.first_name} ${option.last_name}`}
                      value={selectedPersonnel || null}
                      onChange={(event, personnelNewValue: UserBasic | null) => {
                        setSelectedPersonnel(personnelNewValue || undefined);
                        handleChange('personnel', personnelNewValue);
                      }}
                      renderOption={(props, option) => {
                        // NEW LOGIC: Using is_available flag from API response
                        const isAvailable = (option as UserBasic).is_available;
                        // OLD LOGIC: const isAvailable = availableRoleList.some((user) => user.id === option.id);
    
                        return ( 
                          <li {...props} key={option.id}>
                            <Typography
                              style={{
                                color: isAvailable ? 'green' : 'red',
                                fontWeight: isAvailable ? 'bold' : 'normal',
                              }}
                            >
                              {option.first_name} {option.last_name}
                            </Typography>
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          disabled={!(timeFrom && timeTo)}
                          label={
                            departmentName === 'Admin' || departmentName === 'Semen Collection'
                              ? RequiredLabel(tAppointmentForm('personnelLabel'), true)
                              : departmentName === 'Pathology'
                                ? RequiredLabel(tAppointmentForm('pathologistLabel'), true)
                                : ['Surgery', 'Ultrasound', 'Counselor'].includes(departmentName)
                                  ? RequiredLabel(tAppointmentForm('doctorNameLabel'), false)
                                  : RequiredLabel(tAppointmentForm('doctorNameLabel'), false)
                          }
                          variant="outlined"
                          error={!!formErrors.personnel}
                        />
                      )}
                      disabled={!selectedDepartment || !timeFrom || !timeTo}
                    />
                  </FormControl>
                </Grid2>

                <Grid2 size={{xs:6, sm:4, lg:4}}>
                  <FormControl fullWidth size="small" error={!!formErrors.appointmentReason}>
                    <Autocomplete
                      options={appointmentReasonsList}
                      getOptionLabel={(option) => option.reason}
                      value={appointmentReasonsList.find(reason => reason.id === selectedAppointmentReason) || undefined}
                      onChange={(event, newValue) => {
                        handleChange('appointmentReason', newValue ? newValue.id : undefined);
                      }}
                      disabled={departmentName !== 'Admin' && departmentName !== 'Semen Collection' && departmentName !== 'Pathology' ? !selectedPersonnel?.first_name.length ? true : false : false}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tAppointmentForm('appointmentReasonLabel'), true)}
                          variant="outlined"
                          error={!!formErrors.appointmentReason}
                        />
                      )}
                      size="small"
                      disableClearable
                      noOptionsText={tAppointmentForm('noOptionsText')}
                    />
                  </FormControl>
                </Grid2>

                {departmentName === 'Surgery' && (
                  <>
                    <Grid2 size={{xs:6, sm:4}} >
                      <FormControl fullWidth size="small" error={!!formErrors.room}>
                        <InputLabel id="room-label">{RequiredLabel(tAppointmentForm('roomLabel'), true)}</InputLabel>
                        <Select
                          labelId="room-label"
                          id="room-select"
                          value={selectedRoom || ''}
                          onChange={(e) => handleChange('room', Number(e.target.value))}                          
                          label={RequiredLabel(tAppointmentForm('roomLabel'), true)}
                        >
                          {room.map((roomItem) => (
                            <MenuItem key={roomItem.id} value={roomItem.id}>
                              {roomItem.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid2>

                    <Grid2 size={{xs:6, sm:4}}>
                      <FormControl fullWidth size="small" error={!!formErrors.table && (selectedRoom !== undefined)}>
                        <InputLabel id="table-label">{RequiredLabel(tAppointmentForm('tableLabel'), true)}</InputLabel>
                        <Select
                          labelId="table-label"
                          id="table-select"
                          value={selectedTable || ''}
                          onChange={(e) => handleChange('table', e.target.value)}
                          label={RequiredLabel(tAppointmentForm('tableLabel'), true)}
                          disabled={!selectedRoom}
                          className={!selectedRoom ? 'disabled-select' : ''}
                        >
                          {table.map((tableItem) => (
                            <MenuItem key={tableItem.id} value={tableItem.id}>
                              {tableItem.name}
                            </MenuItem>
                          ))}
                        </Select>
                        {/* <FormHelperText>{formErrors.table}</FormHelperText> */}
                      </FormControl>
                    </Grid2>
                  </>
                )}

                <Grid2 size={{xs:6, sm:4, lg:4}}>
                  <TextField
                    fullWidth
                    size="small"
                    id="appointmentDate"
                    label={RequiredLabel(tAppointmentForm('dateLabel'), true)}
                    type="date"
                    name="appointmentDate"
                    slotProps={{
                      inputLabel: { shrink: true },
                    }}
                    variant="outlined"
                    // bind to string state to allow manual typing
                    value={appointmentDateStr}
                    onChange={(e) => handleChange('appointmentDate', e.target.value)}
                    error={!!formErrors.appointmentDate}
                  />
                </Grid2>

                {/* Time From */}
                <Grid2 size={{xs:6, sm:4, lg:4}}>
                  <TextField
                    fullWidth
                    size="small"
                    id="timeFrom"
                    label={RequiredLabel(tAppointmentForm('timeFromLabel'), true)}
                    type="time"
                    slotProps={{inputLabel:{shrink:true}}}
                    variant="outlined"
                    value={timeFrom}
                    onChange={(e) => handleChange('timeFrom', e.target.value)}
                    error={!!formErrors.timeFrom}
                    helperText={formErrors.timeFrom}
                  />
                </Grid2>

                {/* Time To */}
                <Grid2 size={{xs:6, sm:4, lg:4}}>
                  <TextField
                    fullWidth
                    size="small"
                    id="timeTo"
                    label={RequiredLabel(tAppointmentForm('timeToLabel'), true)}
                    type="time"
                    slotProps={{inputLabel:{shrink:true}}}
                    variant="outlined"
                    value={timeTo}
                    onChange={(e) => handleChange('timeTo', e.target.value)}
                    error={!!formErrors.timeTo}
                    helperText={formErrors.timeTo}
                  />
                </Grid2>

                {/* Appointment Type */}
                <Grid2 size={{xs:6, sm:4, lg:4}}>
                  <FormControl fullWidth size="small" error={!!formErrors.appointmentType}>
                    <Autocomplete<AppointmentTypeOption, false, true>
                      options={APPOINTMENT_TYPE_OPTIONS}
                      getOptionLabel={(option) => tAppointmentForm(option.labelKey)}
                      value={APPOINTMENT_TYPE_OPTIONS.find(opt => opt.value === selectedAppointmentMode) || APPOINTMENT_TYPE_OPTIONS[0]}
                      onChange={(event, newValue) => {
                        setSelectedAppointmentMode(newValue.value);
                        if (formErrors.appointmentType) {
                          setFormErrors((prevErrors) => ({
                            ...prevErrors,
                            appointmentType: '',
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tAppointmentForm('appointmentTypeLabel'), true)}
                          variant="outlined"
                          error={!!formErrors.appointmentType}
                        />
                      )}
                      size="small"
                      disableClearable
                    />
                  </FormControl>
                </Grid2>

                <Grid2 size={{xs:12}}>
                  <FormControl fullWidth size="small" error={!!formErrors.remark}>
                    <TextField
                      id="remark"
                      label={tAppointmentForm('remarkLabel')}
                      variant="outlined"
                      value={remark}
                      onChange={(e) => handleChange('remark', e.target.value)}
                      multiline
                      rows={3}
                      slotProps={{htmlInput:{style:{resize:'none'}, maxLength: 2000}}}
                      placeholder={tAppointmentForm('remarkPlaceholder')}
                    />
                  </FormControl>
                </Grid2>
                {tabIndex === 0 && selectedPatientDetails && (
                  <PreviousVisits patientId={selectedPatientDetails.id} />
                )}
              </Grid2>
            </div>
          </ThemeProvider>
        </div>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center' }}>
        {canAdd ? (
          <button
            className={`${styles.save}`}
            onClick={handleOpenConfirmationModal}
            style={{
              fontFamily: 'Montserrat',
              width: '920px',
              height: '46px',
              borderRadius: '12px',
              padding: '12px 40px',
              gap: '10px',
              // NEW LOGIC: Using is_available flag from selectedPersonnel
              backgroundColor: !selectedPersonnel || (selectedPersonnel as UserBasic).is_available ? '#232323' : '#FBEFEF',
              color: !selectedPersonnel || (selectedPersonnel as UserBasic).is_available ? 'white': '#D73B3B',
              border: !selectedPersonnel || (selectedPersonnel as UserBasic).is_available ? 'none' : '1px solid #D73B3B' ,
              // OLD LOGIC: backgroundColor: !selectedPersonnel || availableRoleList.some((user) => user.id === selectedPersonnel?.id) ? '#232323' : '#FBEFEF',
              // OLD LOGIC: color: !selectedPersonnel || availableRoleList.some((user) => user.id === selectedPersonnel?.id) ? 'white': '#D73B3B',
              // OLD LOGIC: border: !selectedPersonnel || availableRoleList.some((user) => user.id === selectedPersonnel?.id) ? 'none' : '1px solid #D73B3B' ,
            }}
          >
            {/* NEW LOGIC: Using is_available flag */}
            {!selectedPersonnel || (selectedPersonnel as UserBasic).is_available
              ? tAppointmentForm('bookAppointmentButton')
              : tAppointmentForm('forceBookAppointmentButton')}
            {/* OLD LOGIC: !selectedPersonnel || availableRoleList.some((user) => user.id === selectedPersonnel?.id) */}
          </button>
        ) : (
          <div style={{ color: '#D73B3B', fontWeight: 'bold', textAlign: 'center', width: '100%' }}>
            {tAppointmentForm('noPermissionToBookAppointment')}
          </div>
        )}
      </DialogActions>

      <ConfirmationModal
        open={openConfirmationModal}
        handleClose={handleCloseConfirmationModal}
        onConfirm={handleSaveAppointment}
        type="save"
        // NEW LOGIC: Using is_available flag from selectedPersonnel
        title={(selectedPersonnel as any)?.is_available ? tAppointmentForm('createAppointmentTitle'): tAppointmentForm('forceBookAppointmentTitle')}
        contentMessage={(selectedPersonnel as any)?.is_available ? tAppointmentForm('createAppointmentConfirm', { patient: getPatientName() }): tAppointmentForm('forceBookAppointmentConfirm', { patient: getPatientName() })}
        // OLD LOGIC: title={availableRoleList.some((user) => user.id === selectedPersonnel?.id) ? tAppointmentForm('createAppointmentTitle'): tAppointmentForm('forceBookAppointmentTitle')}
        // OLD LOGIC: contentMessage={availableRoleList.some((user) => user.id === selectedPersonnel?.id) ? tAppointmentForm('createAppointmentConfirm', { patient: getPatientName() }): tAppointmentForm('forceBookAppointmentConfirm', { patient: getPatientName() })}
      />
    </Dialog>
  );
}
